var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
	'overflow-y': _vm.allowscroll ? 'auto' : 'hidden'
}),attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('back-to-top',{ref:"backToTop"}),_vm._v(" "),_c('feedback'),_vm._v(" "),_c('faq')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }